<h3 class="ui primary header">
  New Chat
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div *ngIf="success || error" appMargin marginY="10px">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>

<div class="content">
  <div class="ui basic vertical segment" *ngIf="stepOne == true">
    <div
      class="ui form"
      [formGroup]="companies"
      [ngClass]="{ loading: pending }"
    >
      <!-- add validation -->
      <!-- <div class="ui input"> -->
      <!-- Search text field -->
      <!-- <div class="icon-input">
        <input
          type="text"
          [placeholder]="placeholder"
          style="border: none"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchRecords($event)"
        />
        <img src="../../../../assets/icons/search.svg" alt="" />
      </div> -->
      <div class="ui left icon input">
        <i class="icon search"></i>
        <input
          type="search"
          placeholder="search"
          formControlName="searchText"
        />
      </div>
      <div class="topics">
        <div class="field" *ngFor="let org of allOrganizations">
          <sui-radio-button
            name="company"
            [value]="org.organizationShortName"
            formControlName="companyName"
            [(ngModel)]="selectedCompanyName"
            (click)="changeName(org.organizationShortName)"
            >{{ org.organizationShortName }}</sui-radio-button
          >
        </div>
      </div>
      <!-- <hr appMargin="40px">
			Selected {{ selectedCompanyName }} -->
    </div>
  </div>
  <div class="ui basic vertical segment" *ngIf="stepTwo == true">
    <h4 class="ui primary header sub-header">Customer</h4>
    <div class="ui divider"></div>
    <span class="selected-company" appMargin marginY="28px">{{
      selectedCompanyName
    }}</span>
    <div
      class="ui form"
      [formGroup]="servicesAndSubGroupsForm"
      [ngClass]="{ loading: pending }"
    >
      <!-- add validation -->
      <!-- <div class="ui input"> -->
      <label class="selection-header-label" style="margin-top: 5px"
        >Which of these service would you like to enquire about?
        <span class="required-input">*</span></label
      >
      <div class="field" *ngFor="let topic of allTopics">
        <sui-radio-button
          [name]="'example'"
          [value]="topic.topicId"
          formControlName="serviceType"
          [(ngModel)]="selectedServiceType"
          (click)="changeType(topic.topicId)"
        >
          {{ topic.topic }}
        </sui-radio-button>
      </div>

      <div *ngIf="selectedServiceType">
        <div class="sub-category">
          <label class="selection-header-label">
            Which of these sub-service would you like to enquire about?
            <span class="required-input">*</span></label
          >
          <div class="field" *ngFor="let subtopic of allSubTopics">
            <sui-radio-button
              [name]="'example1'"
              [value]="subtopic.subtopicId"
              formControlName="subServiceType"
              [(ngModel)]="selectedServiceSubType"
            >
              {{ subtopic.subtopic }}
            </sui-radio-button>
          </div>
          <div class="field" *ngIf="allSubTopics.length < 1">
            <p>There is no Sub services under this service</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="actions" style="background: transparent; border: none">
    <button class="ui basic primary button" (click)="cancel()">Cancel</button>
    <button
      *ngIf="stepOne == true"
      class="ui primary button"
      [ngClass]="{ loading: pending }"
      (click)="continue()"
      autofocus
      [disabled]="!selectedCompanyName"
    >
      Continue
    </button>
    <button
      *ngIf="stepTwo == true"
      class="ui primary button"
      [ngClass]="{ loading: pending }"
      (click)="submit()"
      autofocus
      [disabled]="!selectedServiceSubType"
    >
      Chat with Company
    </button>
  </div>
</div>
